import { useState, useEffect } from 'react';
import { Layout as AntLayout, Menu, Button, Dropdown, Space, Avatar, Select } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    HomeOutlined,
    TeamOutlined,
    ShopOutlined,
    TransactionOutlined,
    MenuOutlined,
    UserOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import '../styles/Layout.css';
import logo from '../assets/img/logo.svg';
import i18n from '../i18n';
import uzFlag from '../assets/flags/uz.png';
import ruFlag from '../assets/flags/ru.png';
import enFlag from '../assets/flags/en.png';

const { Header, Sider, Content } = AntLayout;
const { Option } = Select;

const Layout = ({ children, currentUser, isAdmin, isMerchant }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [language, setLanguage] = useState(i18n.language);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleCollapsed = () => setCollapsed(!collapsed);

    const handleLogoClick = () => navigate('/');

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        window.location.reload();
    };

    const handleLanguageChange = (value) => {
        i18n.changeLanguage(value);
        setLanguage(value);
    };

    const userMenu = {
        items: [
            {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: t('layout.logout'),
                onClick: handleLogout
            }
        ]
    };

    const menuItems = [
        { key: '/', icon: <HomeOutlined />, label: t('layout.menu.home') },
        isAdmin ? { key: '/merchants', icon: <ShopOutlined />, label: t('layout.menu.merchants') } : null,
        isAdmin || isMerchant ? { key: '/bank-accounts', icon: <ShopOutlined />, label: t('layout.menu.bankAccounts') } : null,
        { key: '/terminals', icon: <ShopOutlined />, label: t('layout.menu.terminals') },
        { key: '/static-qr', icon: <TransactionOutlined />, label: t('layout.menu.staticQrs') },
        { key: '/transactions-qr', icon: <TransactionOutlined />, label: t('layout.menu.dynamicQrs') },
        isAdmin ? { key: '/users', icon: <UserOutlined />, label: t('layout.menu.systemUsers') } : null,
    ].filter(Boolean);

    return (
        <AntLayout style={{ minHeight: '100vh' }}>
            <Sider
                className={'sticky-sider'}
                collapsible
                collapsed={collapsed}
                onCollapse={toggleCollapsed}
                breakpoint="lg"
                collapsedWidth={0}
                width={250}
            >
                <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
                    <img src={logo} alt="Logo" className="logo" />
                </div>
                <Menu
                    theme="dark"
                    mode="inline"
                    items={menuItems}
                    onClick={({ key }) => navigate(key)}
                    selectedKeys={[location.pathname]}
                />
            </Sider>
            <AntLayout>
                <Header className="header" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 24px' }}>
                    <div>
                        {(isMobile || collapsed) && (
                            <Button
                                type="primary"
                                icon={<MenuOutlined />}
                                onClick={toggleCollapsed}
                            />
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <Select
                            value={language}
                            onChange={handleLanguageChange}
                            style={{ width: 120 }}
                            dropdownStyle={{ zIndex: 9999 }}
                            optionLabelProp="label"
                        >
                            <Select.Option value="uz" label="O'zbek">
                                <span className="lang-option">
                                    <img src={uzFlag} alt="Uz" className="flag-icon" /> O‘zbek
                                 </span>
                            </Select.Option>
                            <Select.Option value="ru" label="Русский">
                                 <span className="lang-option">
                                     <img src={ruFlag} alt="Ru" className="flag-icon" /> Русский
                                 </span>
                            </Select.Option>
                            <Select.Option value="en" label="English">
                                 <span className="lang-option">
                                    <img src={enFlag} alt="En" className="flag-icon" /> English
                                 </span>
                            </Select.Option>
                        </Select>

                        <Dropdown menu={userMenu} placement="bottomRight">
                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <div style={{ marginRight: '8px', textAlign: 'right' }}>
                                    <div style={{ fontWeight: 'bold', lineHeight: '1.2' }}>{currentUser?.fullname}</div>
                                    <div style={{ fontSize: '12px', lineHeight: '1.2' }}>{currentUser?.phone}</div>
                                </div>
                                <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
                            </div>
                        </Dropdown>
                    </div>
                </Header>
                <Content className="content">{children}</Content>
            </AntLayout>
        </AntLayout>
    );
};

export default Layout;